import { ChevronRight } from "@mui/icons-material";
import { Link } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router";

interface GaiaTableLinkCellProps {
    value: string;
}

export default function GaiaTableLinkCell({ value }: GaiaTableLinkCellProps | GridRenderCellParams) {
    return (
        <>
            <Link
                component={RouterLink}
                to={value}
                sx={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                }}
            />
            <ChevronRight />
        </>
    );
}
